<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="产品代码">
              <a-input
                placeholder="请输入产品代码"
                v-model="queryParam.fundCode"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="净值日期">
              <a-range-picker
                @change="handleChange"
                :placeholder="['净值开始日期', '净值结束日期']"
                :value="createValue"
                format="YYYY-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary">TA净值刷新</a-button>
      <a-button type="primary" @click="handleAdd">手工发布净值</a-button>
      <a-button
        v-if="selectedRowKeys.length > 0"
        type="primary"
        icon="download"
        @click="handleExportXls('产品净值')"
        >导出</a-button
      >
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown> -->
    </div>

    <a-modal
      title="上传文件"
      :visible="showDialog"
      @cancel="showDialog = false"
    >
      <a-upload-dragger
        name="file"
        :multiple="true"
        :file-list="fileList"
        accept=".xls,.xlsx"
        :before-upload="beforeUpload"
        :remove="handleRemove"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">点击或拖拽上传文件</p>
      </a-upload-dragger>
      <template slot="footer">
        <a-button key="back" @click="showDialog = false"> 取消 </a-button>
        <a-button
          :disabled="fileList.length === 0"
          :loading="uploading"
          key="submit"
          type="primary"
          icon="download"
          @click="upload"
        >
          导入
        </a-button>
      </template>
    </a-modal>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        :rowKey="(record) => record.id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
      </a-table>
    </div>

    <productsFundEquity-modal
      ref="modalForm"
      @ok="modalFormOk"
    ></productsFundEquity-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
// import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { filterObj } from '@/utils/util';
import ProductsFundEquityModal from './modules/ProductsFundEquityModal';
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue';
import { uploadAction } from '@/api/manage';
// import { postAction } from '../../../api/manage';
// import customRender from '@/utils/customRender.js';
import { getNetWorthList, netValueEdit } from '@/api/product';

export default {
  name: 'ProductsFundEquityList',
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
    ProductsFundEquityModal,
  },
  data() {
    return {
      description: '产品净值管理页面',
      showDialog: false,
      fileList: [],
      uploading: false,
      loading: false,
      toggleSearchStatus: false,
      selectedRowKeys: [],
      selectionRows: [],
      dataSource: [],
      startTime: null,
      endTime: null,
      queryParam: {
        fundCode: '',
        releaseDate: '',
        endTime: '',
        startTime: '',
      },
      createValue: [],
      superQueryParams: '',

      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      // 表头
      columns: [
        {
          title: '产品代码',
          align: 'center',
          dataIndex: 'fundCode',
          width: 100,
        },
        {
          title: '净值日期',
          align: 'center',
          dataIndex: 'releaseDate',
          width: 150,
          customRender: (text) => {
            return !text || text == '' ? '--' : text.substring(0, 11);
          },
        },
        {
          title: '单位净值',
          align: 'center',
          dataIndex: 'netValue',
          width: 100,
          customRender: (value, row, index) => {
            if (
              (!row.netValue || row.netValue == '') &&
              (!row.manualNetValue || row.manualNetValue == '')
            ) {
              return '--';
            } else if (
              (!row.netValue || row.netValue == '') &&
              row.manualNetValue
            ) {
              return row.manualNetValue;
            } else if (
              row.netValue &&
              (!row.manualNetValue || row.manualNetValue == '')
            ) {
              return row.netValue;
            } else {
              return `${row.manualNetValue}(${row.netValue})`;
            }
            // if (row.netValue == '' || row.netValue == null) {
            //   return (row.netValue = '--');
            // }
            // if (row.manualNetValue == '' || row.manualNetValue == null) {
            //   return (row.manualNetValue = '--');
            // }
            // return row.manualNetValue + ' ' + '( ' + row.netValue + ' )';
          },
        },
        {
          title: '累计净值',
          align: 'center',
          dataIndex: 'totalNetValue',
          width: 100,
          customRender: (value, row, index) => {
            if (
              (!row.totalNetValue || row.totalNetValue == '') &&
              (!row.manualTotalNetValue || row.manualTotalNetValue == '')
            ) {
              return '--';
            } else if (
              (!row.totalNetValue || row.totalNetValue == '') &&
              row.manualTotalNetValue
            ) {
              return row.manualTotalNetValue;
            } else if (
              row.totalNetValue &&
              (!row.manualTotalNetValue || row.manualTotalNetValue == '')
            ) {
              return row.totalNetValue;
            } else {
              return `${row.manualTotalNetValue}(${row.totalNetValue})`;
            }
            // if (row.totalNetValue == '' || row.totalNetValue == null) {
            //   return (row.totalNetValue = '--');
            // }
            // if (
            //   row.manualTotalNetValue == '' ||
            //   row.manualTotalNetValue == null
            // ) {
            //   return (row.manualTotalNetValue = '--');
            // }
            // return (
            //   row.manualTotalNetValue + ' ' + '( ' + row.totalNetValue + ' )'
            // );
          },
        },
        {
          title: '是否手工',
          align: 'center',
          dataIndex: 'isByHand',
          width: 150,

          customRender: (text) => {
            if (text == 0) {
              return '自动';
            } else if (text == 1) {
              return '手工';
            } else if (text == '' || text == null) {
              return '--';
            } else {
              return text;
            }
          },
        },
        {
          title: '每万份计划收益（元）',
          align: 'center',
          dataIndex: 'incomeUnit',
          width: 100,
          customRender: (value, row, index) => {
            // if (row.incomeUnit == '' || row.incomeUnit == null) {
            //   return (row.incomeUnit = '--');
            // }
            // if (row.manualIncomeUnit == '' || row.manualIncomeUnit == null) {
            //   return (row.manualIncomeUnit = '--');
            // }
            // return row.manualIncomeUnit + ' ' + '( ' + row.incomeUnit + ' )';
            if (
              (!row.incomeUnit || row.incomeUnit == '') &&
              (!row.manualIncomeUnit || row.manualIncomeUnit == '')
            ) {
              return '--';
            } else if (
              (!row.incomeUnit || row.incomeUnit == '') &&
              row.manualIncomeUnit
            ) {
              return row.manualIncomeUnit;
            } else if (
              row.incomeUnit &&
              (!row.manualIncomeUnit || row.manualIncomeUnit == '')
            ) {
              return row.incomeUnit;
            } else {
              return `${row.manualIncomeUnit}(${row.incomeUnit})`;
            }
          },
        },
        {
          title: '7日年化收益率（%）',
          align: 'center',
          dataIndex: 'incomeRatio',
          width: 100,
          customRender: (value, row, index) => {
            if (
              (!row.incomeRatio || row.incomeRatio == '') &&
              (!row.manualIncomeRatio || row.manualIncomeRatio == '')
            ) {
              return '--';
            } else if (
              (!row.incomeRatio || row.incomeRatio == '') &&
              row.manualIncomeRatio
            ) {
              return row.manualIncomeRatio;
            } else if (
              row.incomeRatio &&
              (!row.manualIncomeRatio || row.manualIncomeRatio == '')
            ) {
              return row.incomeRatio;
            } else {
              return `${row.manualIncomeRatio}(${row.incomeRatio})`;
            }
            // if (row.incomeRatio == '' || row.incomeRatio == null) {
            //   return (row.incomeRatio = '--');
            // }
            // if (row.manualIncomeRatio == '' || row.manualIncomeRatio == null) {
            //   return (row.manualIncomeRatio = '--');
            // }
            // return row.manualIncomeRatio + ' ' + '( ' + row.incomeRatio + ' )';
          },
        },
      ],
      url: {
        list: process.env.VUE_APP_CMS_PRODUCT + '/product/value/page',
      },
      dictOptions: {},
    };
  },
  computed: {
    importExcelUrl: function () {
      return `${process.env.VUE_APP_GATEWAY_URL}${this.url.importExcelUrl}`;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      return false;
    },
    // 查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = {
        pageNo: that.ipagination.current,
        pageSize: that.ipagination.pageSize,
        fundCode: this.queryParam.fundCode,
        startTime: this.queryParam.startTime,
        endTime: this.queryParam.endTime,
      };
      that.loading = true;
      getNetWorthList(params).then((res) => {
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          that.loading = false;
          that.ipagination.total = res.result.total;
        } else {
          that.$message.error(res.message);
        }
      });
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    handleAdd: function () {
      this.$refs.modalForm.visible = true;
    },
    handleChange(date, dateString, value) {
      this.createValue = date;
      let startTime = dateString[0];
      let endTime = dateString[1];
      this.queryParam.startTime = startTime;
      this.queryParam.endTime = endTime;
      console.log(this.startTime, this.endTime);
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function (value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    modalFormOk() {
      console.warn('1111111');
      // 新增/修改 成功时，重载列表
      this.getList(1);
    },
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      this.createValue = [];
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    upload() {
      let formData = new FormData();
      this.uploading = true;
      formData.set('file', this.fileList[0]);
      uploadAction(this.url.importExcelUrl, formData)
        .then((res) => {
          if (res.success) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.uploading = false;
          this.fileList = [];
          this.showDialog = false;
          this.searchQuery();
        });
    },
    handlePublish(records) {
      console.log(records);
      let params = {
        id: records.id,
        manualIncomeRatio: records.manualIncomeRatio,
        manualIncomeUnit: records.manualIncomeUnit,
        manualNetValue: records.manualNetValue,
        manualTotalNetValue: records.manualTotalNetValue,
      };
      netValueEdit(params).then((res) => {
        if (res.success) {
          this.getList();
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
